import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Index} from 'pages/withAuth/adminPage/procedures/extendChildcare/index'
import {Request} from 'pages/withAuth/adminPage/procedures/extendChildcare/request'
import {ExtendChildcareFlow} from 'pages/withAuth/adminPage/procedures/extendChildcare/flow'
import {Confirm} from 'pages/withAuth/adminPage/procedures/extendChildcare/confirm'

export const ExtendChildcareRoutes: RouteParams[] = [
  {
    key: 'extend_childcare',
    path: WITH_AUTH_ADMIN_PATHS.EXTEND_CHILDCARE.INDEX,
    component: Index,
    exact: true,
  },
  {
    key: 'extend_childcare/request',
    path: WITH_AUTH_ADMIN_PATHS.EXTEND_CHILDCARE.REQUEST,
    component: Request,
    exact: true,
  },
  {
    key: 'extend_childcare/flow/:id',
    path: WITH_AUTH_ADMIN_PATHS.EXTEND_CHILDCARE.FLOW,
    component: ExtendChildcareFlow,
    exact: true,
  },
  {
    key: 'extend_childcare/confirm/:id',
    path: WITH_AUTH_ADMIN_PATHS.EXTEND_CHILDCARE.CONFIRM,
    component: Confirm,
    exact: true,
  },
]
